module.exports = __webpack_public_path__ + "img/grower.dba739ab.png";